function n(n,r){var o=r.rowData,d=r.rowIndex,e=r.columnIndex,a=r._dragHandleProps;return"string"==typeof n?o[n]:n?n(o,{_dragHandleProps:a,columnIndex:e,rowIndex:d}):void 0}export{n as default};
//# sourceMappingURL=getCell.js.map
